import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, Output, EventEmitter, forwardRef, OnInit, AfterViewInit, OnDestroy, ViewContainerRef, ComponentFactoryResolver, ApplicationRef, Injector, ElementRef, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import { Template } from '../../../_models/index';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CdkPortal, DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-custom-select-v4',
  templateUrl: './custom-select-v4.component.html',
  styleUrls: [
    './custom-select-v4.component.css'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectV4Component),
      multi: true
    }
  ]
})
export class CustomSelectV4Component implements ControlValueAccessor, OnChanges {

  @Input() options: Template[] | string[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: 'V1' | 'V2' = 'V1';
  @Input() designVersion: 'V1' | 'V2' = 'V1';
  @Input() hideIcons: boolean = false;
  @Input() isSelectDisabled: boolean = false;
  @Input() labelKey: string = 'label';
  @Input() idKey: string = 'id';

  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  isOpen: boolean = false;
  selectedValue: string | undefined;
  selectedLabel: string | undefined;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      this.updateSelectedValue(this.selectedValue);
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: Template | string) {
    if (this.version === 'V1' && typeof option !== 'string') {
      this.selectedLabel = option[this.labelKey];
      this.selectedValue = option[this.idKey];
    } else if (this.version === 'V2' && typeof option === 'string') {
      this.selectedLabel = option;
      this.selectedValue = option;
    }

    this.isOpen = false;
    this.onChange(this.selectedValue);
    this.onTouch();
    this.selectedOption.emit(this.selectedValue);
  }

  private isArrayOfStrings(arr: any[]): arr is string[] {
    return arr.every(el => typeof el === 'string');
  }

  updateSelectedValue(value: string) {
    if (this.version === 'V1') {
      this.selectedValue = value;

      if ( this.options == undefined || this.isArrayOfStrings(this.options)) {
        return;
      }

      const formControlValue = this.options.find(el => el[this.idKey] === value);
      if (formControlValue != undefined) {
        this.selectedLabel = formControlValue[this.labelKey];
      }

    } else if (this.version === 'V2') {
      this.selectedLabel = value;
      this.selectedValue = value;
    }
  }

  onKeydown(event: KeyboardEvent, option: Template | string) {
    if (event.key === 'Enter') {
      this.selectOption(option);
    }
  }

  writeValue(value: string): void {
    this.updateSelectedValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  onBlur() {
    this.onTouch();
  }

  setDisabledState(isDisabled: boolean): void { }
}
